import { ReactNode } from 'react';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { EmailRedirectedRoutes, RouteConstants } from '../constants/routes';
import { UserStore } from '../store';
import { RedirectRouteInterface } from './types';

const RedirectRoute: RedirectRouteInterface = ({ title = '', children }) => {
  const isLoggedIn = UserStore((state) => state.isLoggedIn);
  const entityCodeList = UserStore((state) => state.entityCodesList);
  const [params] = useSearchParams();
  const code = params.get('code');

  const location = useLocation();
  const { pathname } = location;
  const path = pathname.split('/').slice(-1).toString();

  if (isLoggedIn && Array.isArray(entityCodeList)) {
    return <Navigate to={RouteConstants.HOME} replace />;
  }

  if (
    !code &&
    Object.values(EmailRedirectedRoutes).includes(path as EmailRedirectedRoutes)
  ) {
    return <Navigate to={RouteConstants.LOGIN} replace />;
  }

  return children as ReactNode;
};

export default RedirectRoute;
